'use strict';

import { Entity } from '../Entity';
import { App } from '../App';
import { Agency } from '../Agency/Agency';
import { User } from '../User/User';

export class AgencyDownline extends Entity {
  protected id;
  protected user;
  protected agencyUpline;
  protected agencyAbsoluteUpline;
  protected agentStatus;
  protected agentCommunity;
  protected agentClassification;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.downlineId;
    this.agentStatus = data.agentStatus;
    this.agentCommunity = data.agentCommunity;
    this.agentClassification = data.agentClassification;

    if (data.user) {
      const user = new User();

      user.hydrate(data.user);

      this.user = user;
    }

    if (data.agencyUplineId) {
      const agencyUpline = new Agency();

      agencyUpline.hydrate(data.agencyUplineId);

      this.agencyUpline = agencyUpline;
    }

    if (data.agencyAbsoluteUplineId) {
      const agencyAbsoluteUpline = new Agency();

      agencyAbsoluteUpline.hydrate(data.agencyAbsoluteUplineId);

      this.agencyAbsoluteUpline = agencyAbsoluteUpline;
    }
  }

  public getUser() {
    return this.user;
  }

  public getAbsoluteUpline() {
    return this.agencyAbsoluteUpline;
  }

  public getUpline() {
    return this.agencyUpline;
  }

  public getId() {
    return this.id;
  }

  public getAgentStatus() {
    return this.agentStatus;
  }

  public getAgentCommunity() {
    return this.agentCommunity;
  }

  public getAgentClassification() {
    return this.agentClassification;
  }
}
